<template>
  <div>
    <div class="paragraph">
      <div>
        <v-photoswipe-gallery :isOpen="isOpenGallery" :options="optionsGallery" :items="items" :video="video">
          <v-img slot-scope="props" :src="props.item.src" alt="item" :aspect-ratio="3/2">
              <template v-slot:placeholder>
                  <v-skeleton-loader type="image"></v-skeleton-loader>
              </template>
          </v-img>
        </v-photoswipe-gallery>
      </div>
    </div>
    <v-photoswipe :isOpen="isOpen" :items="items" :options="options" @close="hidePhotoSwipe"></v-photoswipe>
  </div>
</template>  

<script>
import { PhotoSwipe } from 'v-photoswipe'

export default {
  components: {
    'v-photoswipe': PhotoSwipe
  },
  props: ['images','video'],
  data () {
    return {
      isOpen: false,
      isOpenGallery: false,
      options: {
        index: 0,
      },
      optionsGallery: {
        bgOpacity: 1,
        captionEl: false,
        tapToClose: true,
        shareEl: false,
        fullscreenEl: false,
        closeOnScroll:false,
      }
    }
  },
  methods: {
    showPhotoSwipe (index) {
      this.isOpen = true
      this.$set(this.options, 'index', index)
    },
    hidePhotoSwipe () {
      this.isOpen = false
    }
  },
  computed: {
    items () {
      let tenantId = window.tenant;
      let cdnUrl = window.cdn_url;
      var result = [];
      var data = {};
      this.images.forEach((image, index) => {
        data = { src: `${cdnUrl}/activities/images/` + image.image, w: 1600, h: 1066 };
        result.push(data);
      });
      return result;
    }
  }
}  
</script>
